import { APIRoute } from '@/modules/utils'
import { Address } from '@/dataV3/Common/Address'
import { HydraCollection } from 'emt-library'

export const Route: APIRoute = {
  method: 'GET',
  path: `/v2/addresses/retrieve`,
}

export type SearchParams = {
  input?: string
  latitude?: string
  longitude?: string
  strict?: boolean
}

export type Response = HydraCollection<Address>
